/**
 * Independent practice-map route (#1093): /practice-map.
 * A top-level page (NOT under /reports) so the "Practice Map" sidebar item
 * highlights on its own and the page carries no report chrome. Guarded by the
 * reports permission (same data-visibility rules as the report map).
 */
import { createFileRoute } from '@tanstack/react-router'
import { PermissionRouteGuard } from '@/hooks/usePermissions'
import { PracticeMapPage } from '@/components/features/practice-map/PracticeMapPage'

export const Route = createFileRoute('/_authenticated/practice-map')({
  component: () => (
    <PermissionRouteGuard resource="reports" action="view_own">
      <PracticeMapPage />
    </PermissionRouteGuard>
  ),
})
